import React from "react";
import { Form, InputGroup } from "react-bootstrap";

export default function CashBalance({ startBalance, setStartBalance }) {
  return (
    <table className="halfTable">
      <thead className="halfTableheadborder">
        <tr>
          <th className="col-1 normalBorder curve">
            <h4 className="ms-3 mt-2">Start Balance</h4>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <Form.Group>
              <InputGroup size="md" className="">
                <InputGroup.Text className="halfTableInputGroup">
                  £
                </InputGroup.Text>
                <Form.Control
                  type="number"
                  step="any"
                  className="halfTableInput"
                  value={startBalance === 0 ? undefined : startBalance}
                  placeholder="Cash Balance"
                  onChange={(e) => setStartBalance(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
          </td>
        </tr>
      </tbody>
      <tfoot className="foot halfFoot hideBorders">
        <tr>
          <td></td>
        </tr>
      </tfoot>
    </table>
  );
}
